type TermsContentProps = {
  title: string;
  dateText?: string;
  body: string;
};

const TermsContent = ({ title, dateText, body }: TermsContentProps) => (
  <div className="space-y-4 text-gr-600 Body5M14">
    <div className="text-gr-900 Title3S18">{title}</div>
    {dateText && <div className="whitespace-pre-line text-gr-800 Caption1M12">{dateText}</div>}
    <div className="whitespace-pre-line">{body}</div>
  </div>
);

const SERVICE_TERMS_BODY = `제 1 조 [목적]
본 약관은 서클플랫폼 주식회사(이하 "회사")가 제공하는 서비스(이하 "서비스")의 이용과 관련하여 회사와 이용자의 권리ㆍ의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
회사가 제공하는 서비스는 다음과 같으며, 본 서비스 이용약관은 아래 서비스에 적용됩니다. 셀러박스 서비스 (데이터 큐레이션 App), 셀러박스 키워드 서비스 (키워드 검색 및 분석), AI셀러 서비스 (AI 기반 상품 진단)

제 2 조 [용어의 정의]
본 약관에서 사용하는 용어의 정의는 다음과 같습니다.
1. 서비스
셀러박스 : 이용자가 쇼핑몰 판매활동을 통합 관리할 수 있도록 매출관리, 입금관리, 사용자리뷰관리 등을 할 수 있는 서비스를 말합니다.
셀러박스 키워드 : 이용자가 입력한 키워드 또는 상품명에 대해 시장 규모, 예상 매출, 경쟁 강도 등을 분석하는 서비스를 말합니다.
2. 유료서비스 : 회사가 제공하는 서비스로, 월정액 구독 방식으로 이용요금이 부과됩니다.
3. 이용자 : 본 약관에 따라 회사와 서비스 이용계약을 체결하고 회사가 제공하는 서비스를 이용하는 개인 또는 법인을 의미합니다.
4. 아이디(ID) : 이용자 식별과 이용자의 서비스 이용을 위하여 이용자가 선정하고 회사가 승인하는 문자와 숫자의 조합을 의미합니다. 아이디는 이용자의 휴대전화번호 또는 SNS와 연결된 아이디로 관리할 수 있습니다.
5. 닉네임 : 가입 시 부여된 사용자의 별칭 또는 사용자가 직접 정한 이름을 말합니다.
6. 인증번호 : 이용자의 휴대번호를 식별하기 위해 회사 또는 통신사에서 확인 요청하는 숫자의 조합을 의미합니다.
7. 스팸 : 수신자가 원하지 않는데도 불구하고 정보통신망을 통해 일방적으로 전송 또는 게시되는 영리목적의 광고성 정보를 말합니다.
8. 피싱메시지 : 메시지 내용 중 인터넷 주소를 클릭하면 악성코드가 설치되어 수신자가 모르는 사이에 금전적 피해 또는 개인·금융정보 탈취 피해를 야기하는 메시지를 말합니다.
9. 어플리케이션 : 이용자에게 회사의 서비스를 제공할 수 있는 프로그램을 뜻하며, 앱 뿐만 아니라 웹 형태를 모두 포함합니다.

제 3 조 [약관의 게시와 개정]
① 회사는 본 약관의 내용과 함께 상호, 대표자 성명, 회사 소재지 주소, 사업자등록번호, 연락처, 개인정보관리책임자 등을 이용자가 쉽게 알 수 있도록 홈페이지 초기 화면에 게시합니다.
② 회사는 전기통신사업법, 약관 규제에 관한 법률, 개인정보보호법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하 "정보통신망법"), 전자상거래 등에서의 소비자 보호에 관한 법률 등 관련법을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.
③ 회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 제1항의 방식에 따라 그 개정약관의 적용일자 7일 전부터 적용일자 전까지 홈페이지에 공지합니다. 다만, 이용자의 권리 또는 의무에 관한 중요한 규정의 변경은 최소한 30일 전에 공지하고 이용자가 사전에 등록한 전화번호 문자메시지, 서비스 어플리케이션 알림 등의 전자적 수단을 통해 별도로 명확히 통지하도록 합니다.
④ 회사가 본 조 제3항에 따라 개정약관을 공지 또는 통지하면서 이용자에게 약관 변경 적용 일까지 거부의사를 표시하지 않으면 동의한 것으로 본다는 뜻을 명확하게 공지 또는 통지하였음에도 이용자가 명시적으로 거부의 의사표시를 하지 아니한 경우 이용자가 개정약관에 동의한 것으로 봅니다.
⑤ 이용자가 개정약관의 적용에 동의하지 않을 경우 회사는 개정약관의 내용을 적용할 수 없으며, 이 경우 이용자는 이용계약을 해지할 수 있습니다. 다만, 기존 약관을 적용할 수 없는 특별한 사정이 있는 경우에는 회사는 이용계약을 해지할 수 있습니다.
⑥ 본 약관은 이용자가 약관의 내용에 동의함으로써 효력이 발생하며 이용계약 종료 일까지 적용됩니다. 단, 채권 또는 채무관계가 있을 경우에는 채권, 채무의 완료 일까지로 규정합니다.

제 4 조 [약관 외 준칙]
본 약관에서 정하지 않은 사항과 본 약관의 해석에 관하여는 전기통신사업법, 개인정보보호법, 정보통신망법, 전자상거래 등에서의 소비자보호에 관한 법률, 약관의 규제에 관한 법률 및 기타 관계법령('이하 '관계법령') 또는 상관례에 따릅니다. 또한 본 약관과 관계법령의 내용이 충돌하는 경우 관계법령의 규정을 따릅니다.

제 5 조 [이용계약의 체결]
① 이용계약은 이용자가 되고자 하는 자(이하 "가입신청자")가 약관의 내용에 대하여 동의를 한 다음 회원가입신청을 하고 회사가 이러한 신청에 대하여 승낙함으로써 체결됩니다.
② 제1항의 회사의 승낙에 따라 이용자는 유료서비스 이용약관에 정한 바에 따라 이용요금을 납부하고 서비스를 이용할 수 있습니다. 서비스는 월정액 구독 방식으로 제공되며, 이용요금은 월 15,000원(부가세 및 결제수수료 포함)입니다. 단, 회사가 별도의 이벤트 또는 프로모션을 운영하는 경우 해당 기간 동안 이벤트 가격이 적용될 수 있으며, 이벤트 가격은 웹 결제 시에만 적용됩니다.
③ 회사는 가입신청자의 신청에 대하여 서비스 이용을 승낙함을 원칙으로 합니다. 다만, 회사는 다음 각 호에 해당하는 신청에 대하여는 승낙을 하지 않거나 사후에 이용계약을 해지할 수 있습니다.
1. 가입신청자가 본 약관에 의하여 이전에 이용자자격을 상실한 적이 있는 경우, 단 회사의 이용자 재가입 승낙을 얻을 경우에는 예외로 함
2. 실명이 아니거나 타인의 명의를 이용한 경우
3. 허위의 정보를 기재하거나, 회사가 제시하는 내용을 기재하지 않은 경우
4. 만 14세 미만의 가입자인 경우
5. 이용자가 서비스의 정상적인 제공을 저해하거나 다른 이용자의 서비스 이용에 지장을 준 경우
6. 이용자의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반 사항을 위반하며 신청하는 경우
7. 기타 회사가 관련법령 등을 기준으로 하여 명백하게 사회질서 및 미풍양속에 반할 우려가 있음을 인정하는 경우
④ 본 조 제1항에 따른 신청에 있어 회사는 이용자의 종류에 따라 전문기관을 통한 실명확인 및 본인인증을 요청하거나 증빙자료를 요청할 수 있습니다.
⑤ 회사는 본 조 제3항 각호에 따라 이용신청이 이루어지지 않는지 관리·감독할 수 있습니다.
⑥ 회사는 다음 각호에 해당하는 신청에 대해서는 승낙을 지연할 수 있습니다.
1. 회사의 설비에 여유가 없거나 기술적 장애가 있는 경우
2. 서비스 상의 장애 또는 서비스 이용요금 결제수단의 장애가 발생한 경우
3. 기타 회사가 재정적, 기술적으로 필요하다고 인정하는 경우
⑦ 회사와 이용자가 서비스 이용에 관하여 별도의 계약을 체결한 경우, 당해 별도의 계약이 본 약관에 우선하여 적용됩니다.

제 6 조 [개인정보 수집]
① 회사는 적법하고 공정한 수단에 의하여 이용계약의 성립 및 이행에 필요한 최소한의 개인정보를 수집합니다.
② 회사는 개인정보의 수집 시 관련법규에 따라 개인정보처리방침에 그 수집범위 및 목적을 사전 고지합니다.
③ 회사는 서비스 화면에서 회사가 수집한 개인정보의 수집, 이용 또는 제공에 대한 동의를 철회할 수 있도록 필요한 조치를 취해야 합니다.

제 7 조 [개인정보보호 의무]
① 회사는 개인정보보호법, 정보통신망법 등 관계 법령이 정하는 바에 따라 이용자의 개인정보를 보호하기 위해 노력합니다.
② 개인정보의 보호 및 사용에 대해서는 관련법 및 회사의 개인정보처리방침이 적용됩니다. 다만, 회사의 공식 사이트 이외의 링크된 사이트에서는 회사의 개인정보처리방침이 적용되지 않습니다.

제 8 조 [이용자의 아이디 및 비밀번호의 관리에 대한 의무]
① 이용자는 서비스 이용을 위한 아이디 및 비밀번호의 관리에 대한 책임, 본인 아이디의 제3자에 의한 부정사용 등 이용자의 고의 또는 과실로 인해 발생하는 모든 불이익에 대한 책임을 부담합니다.
② 이용자에게 통보된 서비스 ID 또는 비밀번호에 의하여 발생되는 제3자에 의한 부정사용 또는 회사의 의사와 무관한 서비스 사용상의 불법행위 내지 과실에 대한 모든 책임은 이용자에게 있습니다. 다만, 회사의 고의 또는 과실이 있는 경우에는 그러하지 아니합니다.
③ 회사는 이용자의 아이디가 개인정보 유출 우려가 있거나 반사회적 또는 미풍양속에 어긋나거나 회사 또는 회사의 운영자로 오인할 우려가 있는 경우 해당 아이디의 활용을 제한할 수 있습니다.
④ 이용자는 아이디 및 비밀번호가 도용되거나 제3자가 사용하고 있음을 인지한 경우에는 이를 즉시 회사에 통지하고 회사의 안내에 따라야 합니다.
⑤ 본 조 제4항의 경우에 해당 이용자가 회사에 그 사실을 통지하지 않거나 통지한 경우에도 회사의 안내에 따르지 않아 발생한 불이익에 대하여 회사는 책임지지 않습니다.

제 9 조 [이용자 정보의 변경]
① 이용자는 개인정보관리화면을 통하여 본인의 개인정보를 열람하고 수정할 수 있습니다. 다만, 서비스 관리를 위해 필요한 실명, 아이디 등은 홈페이지에 기재된 회사의 전화번호 또는 이메일, 정해진 양식 작성을 통해 수정을 요청하여야 합니다.
② 이용자는 서비스 이용신청 시 기재한 사항이나 서비스 이용 과정에서 회사에 제공한 정보가 변경되었을 경우 본 조 제1항의 방법으로 이용자 정보를 변경하여야 하며, 변경사항을 수정하지 않아 발생한 불이익에 대하여 회사는 책임지지 않습니다.

제 10 조 [이용자에 대한 통지]
① 회사가 이용자에 대한 통지를 하는 경우 본 약관에 별도 규정이 없는 한 이용자의 등록된 전화번호 등으로 통지할 수 있습니다.
② 회사는 전체에 대한 통지의 경우 7일 이상 서비스 공지사항에 게시함으로써 제1항의 통지에 갈음할 수 있습니다.
③ 이용자는 회사에 실제로 연락이 가능한 이메일, 전화번호 등의 정보를 제공하고 해당 정보들을 최신으로 유지하여야 하며 회사의 통지를 확인하여야 합니다.

제 11 조 [회사의 의무]
① 회사는 관련법과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로 서비스를 제공하기 위하여 최선을 다하여 노력합니다.
② 회사는 이용자가 안전하게 서비스를 이용할 수 있도록 개인정보 보호를 위해 보안시스템을 갖추어야 하며 개인정보처리방침을 공시하고 준수합니다.
③ 회사는 서비스 제공과 관련하여 알고 있는 이용자의 개인정보를 이용자의 승낙 없이 제3자에게 누설, 배포하지 않습니다. 다만, 관계법령에 의한 관계기관으로부터의 요청 등 법률의 규정에 따른 적법한 절차에 의한 경우에는 그러하지 않습니다.
④ 회사는 이용자에게 제공하는 서비스를 계속적이고 안정적으로 제공하기 위하여 설비에 장애가 생기거나 멸실 되었을 때 지체 없이 이를 수리 또는 복구할 수 있도록 노력합니다. 다만, 천재지변이나 비상사태 등 부득이한 경우에는 서비스를 일시 중단하거나 영구 중지할 수 있습니다.
⑤ 회사는 이용자로부터 제기되는 의견이나 불만이 정당하다고 인정할 경우에는 즉시 처리하여야 합니다. 다만, 즉시 처리가 곤란한 경우는 이용자에게 그 사유와 처리일정을 전자메일 등으로 통보하여야 합니다.
⑥ 회사는 서비스 제공목적에 맞는 서비스 이용 여부를 확인하기 위하여 상시적으로 모니터링을 실시합니다.
⑦ 회사는 스팸 또는 피싱메시지(이하 통칭하여 “불법스팸”)를 전송한 사실을 확인한 경우, 한국인터넷진흥원 불법스팸대응센터에 관련 자료를 첨부하여 신고할 수 있습니다.
⑧ 회사는 불법스팸 발송을 방지하기 위하여 불법스팸으로 인지되는 메시지에 대해 필터링 또는 차단을 할 수 있습니다.
⑨ 회사는 불법스팸 수신거부 처리 등 불법스팸 관련 민원을 자체적으로 처리하기 위한 고충처리창구를 운영합니다.
⑩ 회사는 전기통신사업법 제84조의2 및 과학기술정보통신부 고시 “거짓으로 표시된 전화번호로 인한 피해 예방 등에 관한 고시”(이하 “고시”)에 따라 발신번호 사전등록 서비스를 제공 및 운영합니다.
⑪ 회원이 전기통신사업법 제84조의2 제1항을 위반하여 발신번호를 변작하는 등 거짓으로 표시하는 경우, 회사는 해당 메시지의 전송을 차단할 수 있습니다. 단, “고시” 제7조 제2항에 따라 회사는 전단의 메시지 전송을 차단한 후 지체 없이 당해 차단 사실을 이용자에게 통지합니다.
⑫ 본 조 제11항의 경우 회사는 “고시” 제16조 제1항에 따라 차단된 메시지에 관한 자료(변작된 발신번호, 차단시각, 전송자명 등)를 1년간 보관·관리하고 이를 한국인터넷진흥원에 제출할 수 있습니다.
⑬ 회사는 이용자가 일정기간 생성한 데이터에 대하여 별도의 파일 형태로 제공을 요청하면 이에 응할 수 있습니다. 단, 회사는 이용자에게 요청 파일에 대한 일정 비용을 청구할 수 있습니다.

제 12 조 [이용자의 의무]
① 이용자는 다음 행위를 하여서는 안 됩니다.
1. 서비스 이용 신청 또는 서비스 내용 변경 시 허위내용을 등록하는 행위
2. 타인의 정보나 명의를 도용하거나 부정하게 사용하는 행위
3. 다른 이용자의 개인정보를 동의 없이 수집, 저장, 공개하는 행위
4. 회사가 게시한 정보를 변경하거나 제3자에게 제공하는 행위
5. 회사 또는 제3자의 저작권 등 지식재산권에 대한 침해 행위
6. 회사 또는 제3자의 명예를 손상시키거나 업무를 방해하는 행위
7. 외설 또는 폭력적인 메시지, 팩스, 음성, 메일, 기타 공서양속에 반하는 정보를 서비스에 공개 또는 게시하는 행위
8. 회사의 동의 없이 본 약관의 목적 범위를 벗어나 영리를 목적으로 서비스를 사용하는 행위
9. 타인의 의사에 반하는 내용을 지속적으로 전송하는 행위
10. 범죄행위를 목적으로 하거나 범죄행위를 교사하는 행위
11. 선량한 풍속 또는 기타 사회질서를 해치는 행위
12. 현행 법령, 회사가 제공하는 서비스에 정한 약관, 이용안내 및 서비스와 관련하여 공지한 주의사항, 회사가 통지하는 사항, 기타 서비스 이용에 관한 규정을 위반하는 행위
13. 서비스의 안정적인 운영에 지장을 주거나 줄 우려가 있는 일체의 행위
14. 제3자에게 임의로 서비스를 임대하는 행위
15. 전기통신사업법 제84조의2 제1항을 위반하여 메시지 전송 시 발신번호를 변작하는 등 거짓으로 표시하는 행위
16. 서비스를 불법스팸 전송에 이용하는 행위
17. 기타 불법적이거나 부당한 행위
② 이용자는 관계법, 본 약관의 규정, 이용안내 및 서비스와 관련하여 공지한 주의사항, 회사가 통지하는 사항 등을 준수하여야 하며, 기타 회사의 업무에 방해되는 행위를 하여서는 안 됩니다.
③ 이용자는 회사가 정한 유료서비스 이용요금을 지정된 날짜에 납입할 의무가 있습니다.
④ 이용자는 정보통신망법의 광고성 정보 전송 시 의무사항 및 회사의 이용약관을 준수하여야 합니다.
⑤ 이용자는 불법스팸 전송 등 불법행위를 하거나 전기통신사업법 등 관련 법령을 준수하지 않아 발생하는 모든 민ㆍ형사상의 책임을 부담합니다.
⑥ 전기통신사업법 제84조의2에 의거 이용자는 본인의 발신번호를 사전에 등록하고 등록된 번호로만 발송해야 하며, 메시지 전송 시 발신번호를 변작하는 등 거짓으로 표시하여서는 안됩니다.

제 13 조 [불만처리]
① 회사는 개인정보와 관련하여 이용자의 의견을 수렴하고 불만을 처리하기 위한 절차를 마련하여야 합니다.
② 회사는 전화, 전자우편 또는 서비스 화면의 상담창구를 통하여 이용고객의 불만사항을 접수, 처리하여야 합니다.

제 14 조 [서비스 제공]
① 회사는 이용자에게 제공하는 서비스를 홈페이지에 게시합니다.
② 서비스는 연중무휴, 1일 24시간 제공함을 원칙으로 합니다. 단, 회사는 서비스 제공에 필요한 경우 정기점검을 실시할 수 있으며 정기점검시간은 서비스 화면 등에 회사가 사전에 공지한 바에 따릅니다.
③ 회사는 서비스를 일정범위로 분할하여 각 범위 별로 이용가능 시간을 별도로 지정할 수 있습니다. 다만 이러한 경우에는 그 내용을 사전에 공지합니다.
④ 회사는 다음 각 호에 해당하는 경우 서비스의 전부 또는 일부를 제한하거나 중지할 수 있습니다.
1. 서비스용 설비의 보수 등 공사로 인한 부득이한 경우
2. 정전, 제반 설비의 장애 또는 이용량의 폭주 등으로 정상적인 서비스 이용에 지장이 있는 경우
3. 천재지변, 국가비상사태 등 불가항력적 사유가 있는 경우
4. 기타 서비스를 유지할 수 없는 중대한 사유가 발생한 경우
⑤ 본 조 제4항의 경우 회사는 제10조에서 정한 방법으로 이용자에게 통지합니다. 다만, 회사가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.
⑥ 이용자가 유료서비스를 이용하는 경우, 서비스 이용기간, 서비스 이용요금, 납부절차 등은 별도의 서비스 내용을 홈페이지나 서비스 어플리케이션을 통해 통지할 수 있습니다.
⑦ 회사는 이용자의 무료서비스 이용 시 이용자가 업로드 하는 데이터를 관리해야 할 의무가 없으며 무료서비스 이용과 관련한 어떠한 책임도 부담하지 않습니다.

제 15 조 [서비스의 변경 또는 중단]
① 회사는 상당한 이유가 있는 경우에 회사의 정책상, 운영상, 기술상의 필요에 따라 제공하고 있는 서비스의 전부 또는 일부를 변경 또는 중단할 수 있으며, 이에 대하여 관련 법에 특별한 규정이 없는 한 이용자에게 별도 보상을 하지 않습니다.
② 서비스의 내용, 이용방법, 이용시간에 대하여 변경 또는 중단이 있는 경우에는 변경 또는 중단 사유, 변경 또는 중단될 서비스의 내용 및 제공일자 등을 그 변경 또는 중단 전에 제10조의 방법으로 이용자에게 통지합니다.
③ 회사가 제공하기로 한 유료서비스의 내용을 기술적 사양의 변경 또는 특정서비스의 중지의 사유로 변경함으로 인해 이용자가 입은 손해에 대해서 회사는 이용요금 환불, 서비스의 개선 등 적절한 조치를 취합니다. 다만, 회사에게 귀책사유가 없는 경우와 부득이한 사유로 인해 관련법규 또는 합리적인 상행위 관행에 따른 조치로서 변경일자 7일 이전에 게시한 경우에는 그러하지 아니합니다.

제 16 조 [서비스 이용의 제한 및 정지]
① 회사는 주민등록법을 위반한 명의도용 및 결제도용, 저작권법을 위반한 불법프로그램의 제공 및 운영방해, 정보통신망법을 위반한 불법통신, 해킹, 악성프로그램의 배포, 접속권한 초과행위 등과 같이 관련법을 위반한 경우에는 즉시 영구이용정지를 할 수 있습니다. 본 항에 따른 서비스 이용정지 시 서비스 내의 혜택 및 권리 등도 모두 소멸되며 회사는 이에 대해 별도로 보상하지 않습니다.
② 회사는 다음 각 호에 해당하는 경우에 이용자의 서비스 이용을 제한할 수 있습니다.
1. 이용자가 유료서비스 이용 기간 만료일 경과 후에도 이용요금을 납부하지 않을 경우
2. 제12조 규정에 의한 이용자의 의무를 이행하지 아니한 경우
3. 이용자의 이름 등 이용자 정보가 정확하지 않은 경우
4. 다른 이용자 또는 제3자의 지식재산권을 침해하거나 명예를 손상시킨 경우
5. 방송통신심의위원회의 시정요구가 있거나 불법선거운동과 관련하여 선거관리위원회의 유권해석을 받은 경우
6. 공공질서 및 미풍양속에 저해되는 내용을 고의로 유포시킨 경우
7. 이용자가 서비스를 임의로 재판매 하거나 변형하여 제3자가 이용하도록 하는 경우
8. 서비스를 이용하여 얻은 정보를 이용고객의 개인적인 이용 이외에 복사, 가공, 번역, 2차적 저작물 등을 제작하여 복제, 공연, 방송, 전시, 배포, 출판 등에 사용하는 경우
9. 기타 회사가 이용자로 부적당하다고 판단한 경우
10. 이용자가 서비스에 대량의 트래픽을 발생시키는 경우
③ 회사는 이용자가 다음 중 하나에 해당하는 경우 1개월 동안의 기간을 정하여 당해 서비스의 이용을 정지할 수 있습니다.
1. 방송통신위원회 또는 한국인터넷진흥원 등 관계기관이 불법스팸 전송사실을 확인하여 이용정지를 요청하는 경우
2. 이용자가 전송하는 광고로 인하여 회사의 서비스 제공에 장애를 야기하거나 야기할 우려가 있는 경우
3. 이용자가 전송하는 광고의 수신자가 불법스팸으로 신고하는 경우
4. 이용자가 제12조 제1항 제15호를 위반하여 발신번호를 변작하는 등 거짓으로 표시한 경우
5. 과학기술정보통신부장관 또는 한국인터넷진흥원 등 관련 기관이 발신번호를 변작 등을 확인하여 이용 정지를 요청하는 경우
④ 회사가 본 조 제2항 내지 제3항의 규정에 의하여 서비스를 제한 또는 정지하는 경우, 그 사실을 이용자에게 사전 통보하여야 합니다. 다만, 사전에 통보하는 것이 곤란할 경우 이용정지 조치 후 통보할 수 있습니다.
⑤ 회사는 12개월 이상 서비스를 이용하지 아니하는 이용자의 개인정보를 보호하기 위해 이용자의 계정을 휴면계정으로 분류하고 서비스 이용계약을 해지하거나 개인정보의 파기 또는 별도 분리보관 등 필요한 조치를 할 수 있습니다.
⑥ 회사는 휴면계정으로 분류되기 30일 전까지 개인정보가 파기되거나 분리되어 저장되는 사실과 기간 만료일 및 해당 개인정보의 항목을 이메일, 서면, 모사전송, 전화 또는 유사한 방법 중 하나의 방법으로 이용자에게 알리도록 합니다. (단, 이용자의 정보가 정확하지 않은 경우 알림 대상에서 제외될 수 있습니다.)
⑦ 본 조에 의한 서비스 이용 정지 또는 이용 계약의 해지 시 데이터 삭제에 대한 책임은 이용자가 부담하며, 회사는 고의 또는 과실이 없는 한 데이터 삭제에 따른 책임을 부담하지 않습니다.
⑧ 이용자가 유료서비스 이용요금을 미납하거나 결제가 실패한 경우, 회사는 서비스 이용을 제한할 수 있습니다. 이 경우 이용자의 데이터는 서비스 이용 제한일로부터 90일간 보관되며, 90일 이내에 결제가 완료될 경우 서비스 및 데이터가 복구됩니다. 90일이 경과하도록 결제가 이루어지지 않을 경우 데이터는 삭제되며, 이에 대한 책임은 이용자가 부담합니다.

제 17 조 [이용요금 등의 종류]
① 서비스 이용과 관련하여 이용자가 납부하여야 할 이용요금은 홈페이지나 서비스 어플리케이션에 게재한 바에 따릅니다. 단, 홈페이지와 서비스 어플리케이션에 게재된 이용요금이 상이한 경우 서비스 어플리케이션 기준을 우선하여 적용됩니다.
② 서비스는 월정액 유료 구독 방식으로 제공되며, 이용요금은 월 15,000원(부가세 및 결제수수료 포함)입니다. 이용요금은 월단위로 납부하며, 선불결제를 원칙으로 합니다.
③ 이벤트 또는 프로모션 할인가는 웹(PC 및 모바일 웹) 결제 시에만 적용됩니다. 구글 플레이 또는 애플 앱스토어를 통한 앱 내 결제(인앱결제)의 경우 이벤트 할인가가 적용되지 않으며 정가 15,000원이 결제됩니다.
④ 서비스 이용요금은 등록된 결제 수단으로 매월 정기 결제일에 자동으로 결제됩니다. 회사는 자동 결제일 3일 전에 이메일 및 앱 푸시 알림을 통해 이용자에게 사전 고지합니다.

제 18 조 [불법 면탈 요금의 청구]
① 이용자가 불법으로 서비스 이용요금 등을 면탈할 경우에는 면탈한 금액의 2배에 해당하는 금액을 청구합니다.
② 회사는 2개월 이상 서비스 이용요금이 연체된 이용자를 신용기관에 신용불량자로 등록할 수 있습니다.

제 19 조 [이용요금 등의 환불]
① 이용자는 이용계약을 해지하고자 할 때 앱 내 설정 > 구독 관리 메뉴를 통하거나, 전자우편·전화 등의 방법으로 회사에 신청하여야 합니다.
② 이용자는 전자상거래 등에서의 소비자보호에 관한 법률에 따라 결제일로부터 7일 이내에 서비스를 이용하지 않은 경우 청약철회를 요청할 수 있으며, 이 경우 전액 환불됩니다. 단, 서비스를 일부라도 이용한 경우에는 청약철회가 제한될 수 있습니다.
③ 결제일로부터 7일이 경과하거나 서비스를 이용한 경우에는 원칙적으로 환불이 진행되지 않습니다.
④ 이벤트 할인가(얼리버드 및 첫 달 할인 포함)로 결제한 경우, 청약철회 시 실제 결제 금액을 기준으로 환불됩니다.

제 20 조 [이용계약 해지]
① 이용자는 이용계약을 해지 하고자 할 때 본인이 직접 서비스를 통하여 신청하거나 전자우편, 전화 등의 방법을 통하여 회사에 신청하여야 합니다.
② 회사는 본 조 제1항의 규정에 의하여 해지신청이 접수되면 즉시 이용계약을 해지합니다. 단, 별도의 채권·채무관계가 있을 경우에는 그러하지 아니합니다.
③ 회사는 이용자가 다음 각 호에 해당할 경우에는 이용자의 동의 없이 이용계약을 해지할 수 있으며 그 사실을 이용자에게 통지합니다. 다만 회사가 긴급하게 해지할 필요가 있다고 인정하는 경우나 이용자의 귀책사유로 인하여 통지할 수 없는 경우에는 지체 없이 사후 통지로 대체 할 수 있습니다.
1. 타인의 명의로 서비스 계약을 체결하였거나 서비스 계약 체결 시 제출한 자료 및 정보가 허위 또는 누락 되었음이 확인된 경우
2. 이용자가 제12조를 포함한 본 약관을 위반하고 일정 기간 이내에 위반 내용을 해소하지 않는 경우
3. 회사의 서비스 제공목적 외의 용도로 서비스를 이용하거나 제3자에게 임의로 서비스를 임대한 경우
4. 방송통신위원회 또는 한국인터넷진흥원 등이 불법스팸의 전송사실을 확인하여 회사에게 서비스 계약 해지를 요청하는 경우
5. 이용자가 제12조 제6항을 위반하여 발신번호를 변작하는 등 거짓으로 표시한 경우
6. 제16조 규정에 의하여 이용정지를 당한 이후 1년 이내에 이용정지 사유가 재발한 경우
7. 회사의 유료서비스 이용요금 등의 납입청구에 대하여 이용자가 이용요금을 체납할 경우
④ 이용자 또는 회사가 계약을 해지할 경우 관련법 및 개인정보처리방침에 따라 회사가 이용자 정보를 보유하는 경우를 제외하고는 해지 즉시 이용자의 모든 데이터는 소멸될 수 있으며, 소멸된 데이터는 어떤 경우에도 이용자에게 반환되지 않습니다.
⑤ 본 조에 따라 서비스 이용계약 해지에 따른 이용자의 손해가 발생한 경우 회사는 책임을 부담하지 않습니다. 단, 회사의 귀책사유로 인하여 서비스 이용계약이 해지되는 경우에는 그러하지 않습니다.

제 21 조의 [무료 플랜 폐지 및 유예 기간]
① 회사는 2026년 6월 8일부로 무료 플랜을 폐지합니다.
② 2026년 6월 8일 기준 무료 플랜을 이용 중인 이용자에게는 2026년 7월 8일까지 30일의 유예 기간을 부여하며, 유예 기간 동안 기존 무료 플랜 기능을 그대로 이용할 수 있습니다.
③ 유예 기간 종료 후 유료 멤버십으로 전환하지 않은 이용자는 서비스 이용이 제한됩니다. 이 경우 이용자의 데이터는 서비스 이용 제한일로부터 90일간 보관되며, 90일 이내에 유료 결제를 완료할 경우 서비스 및 데이터가 복구됩니다.
④ 유예 기간 중 유료 멤버십으로 전환하는 이용자에게는 회사가 별도로 정한 이벤트 혜택이 적용될 수 있습니다.

제 22 조 [각종 데이터의 보관기간]
회사는 이용자의 정상적인 서비스 이용 중 이용자가 저장하고 있는 자료에 대하여 보관기간을 정하고 있으며, 개인정보처리방침에 데이터의 보관기간을 사전고지합니다. 회사는 필요에 따라 이용자에게 사전 공지 후 보관기간을 변경할 수 있습니다.

제 23 조 [지식재산권]
① 서비스 자체에 대한 지식재산권은 회사에 귀속됩니다. 다만, 이용자가 서비스 페이지에 게시하거나 등록한 자료의 지식재산권은 이용자에게 귀속됩니다.
② 이용자가 서비스를 통하여 업로드하는 이미지나 자료가 제3자의 저작권 및 지식재산권을 침해하여서는 안되며 이로 인해 발생하는 모든 문제는 전적으로 이용자의 책임이며, 회사와 제3자 사이에 분쟁이 발생시 이용자의 비용으로 이를 보상 혹은 배상해야 합니다.

제 24 조 [광고게재]
① 회사는 서비스의 운영과 관련하여 서비스 어플리케이션 화면, 이메일 등에 광고를 게재할 수 있습니다. 단 이용자가 원하지 않는 경우에는 영리목적의 광고성 전자우편을 발송하지 않습니다.
② 이용자는 본조 제1항에 따라 게재된 광고내용이나 회사를 통한 광고주의 판촉활동에 대하여 본인의 책임과 판단 하에 참여하며, 그 결과로 발생하는 모든 손실 또는 손해에 대해서 회사는 책임을 지지 않습니다.

제 25 조 [쇼핑몰 및 솔루션 연동]
① 이용자는 서비스 이용을 위하여 회사가 쇼핑몰에 자동 로그인할 수 있도록 조치를 취할 의무를 지닙니다.
② 쇼핑몰이 자동 로그인 방식을 차단하는 경우, 서비스 어플리케이션과 쇼핑몰 간의 연동이 중단될 수 있습니다.
③ 쇼핑몰의 정책 변경 또는 쇼핑몰이 회사와의 연동을 일방적으로 중단하는 등 불가피하게 쇼핑몰과의 연동을 유지할 수 없는 사정이 발생한 경우, 회사는 쇼핑몰과의 연동을 중단할 수 있으며, 이 경우 이용자에게 발생한 손해에 대해서는 책임을 부담하지 않습니다.

제 26 조 [손해배상의 범위 및 청구]
① 회사의 귀책사유로 인한 유료서비스 장애가 발생하여 이용자가 서비스를 연속 1시간 이상 이용하지 못하였을 경우, 아래와 같이 회사는 이용자에게 무상기간을 제공합니다. 단, 보상의 한도는 무상 서비스 이용기간 최대 15일 제공을 초과하지 않습니다.

장애 발생 시간 (연속)
보상 내용
1시간 이상 3시간 미만
무상 기간 3일 제공
3시간 이상 4시간 미만
무상 기간 6일 제공
4시간 이상 5시간 미만
무상 기간 9일 제공
5시간 이상 6시간 미만
무상 기간 12일 제공
6시간 이상
무상 기간 15일 제공

② 전 1항의 서비스 장애 이외에 회사가 고의 또는 과실로 이용자에게 손해를 끼친 경우, 손해에 대하여 배상할 책임이 있습니다. 이 경우 이용자는 서비스 무상 이용 기간 제공 배상 또는 현금 배상의 방식 중 하나를 선택하고, 이용자에게 발생한 손해에 대한 배상 금액은 이용자와 회사가 합의하여 정합니다. 단, 각 배상 방식 별 손해배상의 한도는 아래의 각 호를 초과하지 않습니다.
1. 무상 서비스 이용 기간 제공 방식 배상 : 이용자의 손해배상 청구일로부터 최근 3개월 평균 이용요금의 3배에 해당하는 무상 서비스 이용기간 제공
2. 현금 배상 : 이용자의 손해배상 청구일로부터 최근 3개월 평균 월 서비스 이용요금의 2배에 해당하는 현금의 배상
③ 회사는 그 손해가 천재지변 등 불가항력이거나 이용자의 고의 또는 과실로 인하여 발생된 때에는 손해배상을 하지 않습니다.
④ 이용자가 고의 또는 과실로 회사에 손해를 끼친 경우, 이용자는 회사에 대하여 발생한 손해를 배상할 책임이 있습니다.
⑤ 이용자는 불법스팸 전송 등 불법행위를 하거나 전기통신사업법 등 관련 법령을 준수하지 못해 발생하는 모든 민형사상의 책임을 부담하며, 회사는 면책됩니다.
⑥ 손해배상의 청구는 회사에 청구사유, 청구금액 및 산출근거를 기재하여 회사가 정한 방식 (이메일, 전화 등)으로 신청하여야 합니다.
⑦ 회사 및 타인에게 피해를 주어 피해자의 고발 또는 소송 제기로 인하여 손해배상이 청구된 이용자는 회사 및 수사기관의 요청에 적극 협조하여야 합니다.

제 27 조 [면책]
① 회사는 다음 각 호의 경우로 서비스를 제공할 수 없는 경우 이로 인하여 이용자 또는 제3자에게 발생한 손해에 대해서는 책임을 부담하지 않습니다.
1. 천재지변 또는 이에 준하는 불가항력의 상태가 있는 경우
2. 서비스의 효율적인 제공을 위한 시스템 개선, 장비 증설 등 계획된 서비스 중지 일정을 사전에 공지한 경우
3. 이용자의 귀책사유로 서비스 이용에 장애가 있는 경우
4. 회사의 고의 과실이 없는 사유로 인한 경우
5. 회사에게 회선, 통신망, 전용선을 제공하고 있는 이동통신사 또는 부가통신사업자 측의 장애·귀책사유로 인한 서비스의 불완전 또는 불능으로 이용자 또는 제3자에게 야기된 손해
② 회사는 이용자가 서비스를 통해 얻은 정보 또는 자료 등으로 인해 발생한 손해와 서비스를 이용하거나 이용할 것으로부터 발생하거나 기대하는 손익 등에 대하여 책임을 면합니다.
③ 회사는 서비스 이용의 장애로 인하여 발생한 이용자의 부가적, 영업적인 손해에 대해서는 책임을 지지 않습니다.
④ 회사는 이용자가 게시 또는 전송한 데이터의 내용에 대해서는 책임을 면합니다.
⑤ 회사는 이용자 상호 간 또는 이용자와 제3자 상호 간에 서비스를 매개로 하여 거래 등을 한 경우에는 책임을 면합니다.
⑥ 회사는 무료로 제공하는 서비스 이용과 관련하여 관련법에 특별한 규정이 없는 한 책임을 지지 않습니다.
⑦ 회사는 이용자가 서비스 이용 정지 또는 종료 후 제20조에 따라 파기된 데이터와 이용자가 직접 삭제를 요청한 데이터에 대해서는 책임을 지지 않습니다.
⑧ 회사는 회사의 고의 또는 과실이 없는 한 서비스를 활용하여 발송된 메시지 관련 발신자와 수신자 간 분쟁에 대하여 개입할 의무가 없으며 이로 인한 손해를 배상할 책임이 없습니다.
⑨ 회사는 제16조에 따라 이용자의 서비스 이용을 정지 또는 제한하는 경우, 이용의 제한으로 발생할 수 있는 이용자의 손해 등에 대해서는 책임이 면제됩니다.

제 28 조 [분쟁조정]
① 회사와 이용자 간 제기된 소송은 대한민국법을 준거법으로 합니다.
② 서비스 이용과 관련하여 회사와 이용자 간에 발생한 분쟁에 대해서는 민사소송법상의 주소지를 관할하는 법원을 합의관할로 합니다.
③ 해외에 주소나 거소가 있는 이용자의 경우 회사와 이용자간 발생한 분쟁에 관한 소송은 전항에도 불구하고 대한민국 서울중앙지방법원을 관할법원으로 합니다.

* 부 칙 *

개정된 약관은 2022년 8월 15일부터 적용됩니다.
서비스 이용약관 공고일자 : 2022년 08월 01일
서비스 이용약관 시행일자 : 2026년 06월 08일

본 약관은 2021년 11월 15일부터 적용됩니다.
서비스 이용약관 공고일자 : 2021년 11월 01일
서비스 이용약관 시행일자 : 2021년 11월 15일`;

const PRIVACY_POLICY_BODY = `서클플랫폼 주식회사(이하 “회사”)는 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 등 모든 관련 법규를 준수하며, 회사의 서비스를 이용하는 고객(이하 “이용자”)의 개인정보가 보호받을 수 있도록 최선을 다하고 있습니다. ‘개인정보처리방침’이란 이용자의 소중한 개인정보를 보호함으로써 이용자가 안심하고 서비스를 이용할 수 있도록 회사가 준수해야 할 지침을 의미합니다. 회사는 개인정보처리방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 예정이오니 서비스 이용 시에 수시로 확인해주시기 바랍니다.

회사가 제공하는 서비스는 다음과 같으며, 본 개인정보처리방침은 아래 서비스에 적용됩니다.
셀러박스 서비스 (데이터 큐레이션 App), 셀러박스 키워드 서비스 (키워드 검색 및 분석), AI셀러 (AI 기반 반품접수 자동 응대)

제 1 조 [수집하는 개인정보의 항목 및 수집방법]
① 수집하는 개인정보의 항목
1) 회사는 회원가입 또는 서비스 이용 시 고객상담, 각종 서비스의 제공을 위하여 다음과 같은 개인정보를 수집 이용하고 있습니다.
가. 필수정보
- 카카오계정으로 가입한 경우 (아이디, 이름, 이메일주소, 전화번호), 상호(법인명), 성명(대표자명), 사업자등록번호, 업태/업종, 사업장주소 및 우편번호
- 거래쇼핑몰 관리자정보, 거래쇼핑몰 계정정보 (ID, PW, 2차 비밀번호 등), 거래쇼핑몰 주문/정산/반품 정보 (상품명, 주문번호, 주문자 정보, 주문내역, 처리정보 등)
나 .선택정보
- 성별, 생년월일
② 서비스 이용 과정이나 사업 처리 과정에서 다음과 같은 정보들이 자동으로 생성되어 수집될 수 있습니다.
- IP Address, 쿠키, 방문 일시, 검색 이력, 서비스 이용 기록, 불량 이용 기록
③ 유료 서비스 이용 시 다음과 같은 정보들이 수집될 수 있습니다.
가. 신용카드 결제 시 : 카드번호, 유효기간, 생년월일, 카드비밀번호 등
나. 계좌이체 결제 시 : 송금자 이름, 송금 일자, 송금 은행 등
④ 서비스 제공 또는 법정대리인의 동의 절차 등 본인확인이 필요한 경우 다음과 같은 정보가 수집될 수 있습니다.
- 성명, 생년월일, 성별, 내/외국인, 이동전화번호, 이동통신사 정보, 본인확인 값(CI, DI)
1) 개인정보 수집방법
회사는 다음과 같은 방법으로 개인정보를 수집합니다.
가. 홈페이지 회원가입, 서비스 이용, 서면양식, 팩스, 전화, 상담게시판, 이메일, 이벤트 응모, 배송요청 등
나. 제휴사에서 제공받음
다. 금융사(카드, 은행, 보험, 증권 등) 또는 국세청 등에서 공인인증서를 통한 데이터 수집
라. 생성정보수집 도구 활용 등
2) 회사는 기본적 인권침해의 우려가 있는 개인정보(인종 및 민족, 사상 및 신조, 출신지 및 본적지, 정치적 성향 및 범죄기록, 건강상태 및 성생활 등)는 요구하지 않습니다.

제 2 조 [개인정보의 수집 및 이용목적]
회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.
① 서비스 제공에 관한 계약 이행 및 유료 서비스 제공에 따른 요금 정산, 콘텐츠 제공, 유료 서비스 이용에 대한 과금, 구매 및 요금 결제, 본인인증, 물품배송 또는 청구서 등 발송, 요금 추심
② 회원관리 회원제 서비스 이용에 따른 본인확인, 개인식별, 불량회원의 부정 이용 방지와 비인가 사용 방지, 중복가입 확인, 가입의사 확인, 분쟁 조정을 위한 기록보전, 불만처리 등 민원처리, 고지사항 전달
③ 신규 서비스 개발 및 마케팅 및 광고에 활용 신규 서비스 개발 및 맞춤 서비스 제공, 통계학적 특성에 따른 서비스 제공 및 광고 게재, 서비스의 유효성 확인, 접속 빈도 파악, 신규 서비스 개발 및 마케팅 및 광고에 활용, 이벤트 및 프로모션 할인 적용 대상자 확인 및 혜택 제공

제 3 조 [개인정보의 공유 및 제공]
① 회사는 이용자의 개인정보를 제2조(개인정보의 수집 및 이용목적)에서 고지한 범위 내에서 이용하며, 이용자의 사전 동의 없이는 동 범위를 초과하여 이용하거나 타인 또는 타 기관에 제공 또는 공유하지 않습니다. 다만, 다음의 경우에는 예외로 합니다.
1) 이용자가 사전에 동의한 경우
2) 법령의 규정에 의거하거나, 수사상 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우
3) 서비스 제공에 따른 요금 정산을 위해 필요한 경우
4) 통계작성, 학술연구 또는 시장조사를 위하여 개인을 식별할 수 없는 형태로 제공하는 경우
② 회사는 이용자에 대하여 보다 질 높은 서비스 제공 등을 위해 사전에 동의를 획득한 경우에 한하여 이용자의 개인정보를 제공하고 있습니다.

제 4 조 [개인정보의 처리 위탁]
회사는 서비스 이행을 위해 이용자의 개인정보를 위탁 처리할 경우 위탁하는 내용 및 수탁자를 고지하고, 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정해 관련 법규를 준수하고 이를 감독합니다. 회사의 개인정보 위탁처리 기관 및 위탁업무 내용은 다음과 같습니다.

수탁업체
위탁업무 내용
해당없음
결제 처리 및 결제 정보 관리

제 5 조 [개인정보의 보유 및 이용기간]
① 이용자의 개인정보는 이용자가 회원탈퇴를 요청하거나 제공한 개인정보의 수집 및 이용에 대한 동의를 철회하는 경우, 또는 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 다만, 회사는 이용자로부터 개인정보 수집 시 동의받은 개인정보 보유 및 이용기간 내에서 개인정보를 보유, 처리할 수 있습니다. 단, 다음의 정보에 대해서는 보존근거에서 명시한 근거에 따라 보존기간 동안 보존합니다.
1) 서비스 제공을 위해 수집한 회원가입 정보 : 회원 탈퇴 시까지
2) 관련법령에 의한 개인정보 보유
관련법률
보유항목
보유기간
부가가치세법
세금계산서, 영수증 기록
5년
통신비밀보호법
웹사이트 방문 및 로그인 기록
3개월
전자상거래 등에서의
소비자보호에 관한 법률
계약 또는 청약철회 등에 관한 기록
5년
표시/광고에 관한 기록
6개월
대금결제 및 재화 등의 공급에 관한 기록
5년
소비자의 불만 또는 분쟁처리에 관한 기록
3년
전자금융거래법
전자금융 거래에 관한 기록
5년

3) 회사 내부 방침에 따른 회원가입정보 보유
가. 비정상적인 회원탈퇴 등으로 인한 피해예방 : 회원탈퇴 신청 후 7일
나. 부정이용 이슈 방지 : 회원 탈퇴완료 후 6개월 (아이디, 이름, 이메일, 휴대폰번호, 회원과 연계된 정보)
② 개인정보 유효기간제(휴면계정 정책)
1) 1년 이상 서비스 이용기록이 없는 이용자의 회원가입정보는 정보통신망법 제29조에 따라 일반 이용자의 회원가입정보와 분리하여 별도로 저장 및 관리 됩니다. (휴면계정으로 전환)
2) 회사는 휴면계정으로 전환되는 시점 최소 30일 이전, 해당 내용에 대해 앱푸쉬나 이메일 등을 통해 이용자에게 사전 통지합니다.
3) 분리 저장된 개인정보는 관련 법령에 특별한 규정이 있는 경우를 제외하고 해당 개인정보를 이용/제공하지 않습니다.

제 6 조 [개인정보의 파기절차 및 방법]
이용자의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기됩니다. 회사의 개인정보 파기절차 및 방법은 다음과 같습니다.
① 파기절차
가. 자가 회원가입 등을 위해 입력한 정보는 목적이 달성된 후 별도의 DB로 옮겨져 내부방침 및 기타 관계법령에 의한 정보보호 사유에 따라 일정 기간 저장 후 파기됩니다.
나. 상기 개인 정보는 법률로 정한 보유 의무를 정한 경우를 제외하고 다른 목적으로 이용되지 않습니다.
② 파기방법
가. 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.
나. 전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.

제 7 조 [이용자 및 법정대리인의 권리와 그 행사방법]
① 이용자는 언제든지 이용자 본인의 개인정보를 조회하거나 정정할 수 있으며, 가입해지(회원탈퇴) 또는 개인정보의 삭제를 요청할 수 있습니다. 단, 서비스 제공을 위해 반드시 필요한 개인정보를 삭제하는 경우 관련 서비스를 제공받지 못할 수 있습니다.
② 이용자의 개인정보를 조회, 정정하기 위하여는 개인정보변경을 선택하고, 가입해지(동의철회)를 위하여는 서비스 해지를 신청하여 본인 확인 절차 후 직접 조회, 정정 또는 가입해지(동의철회)할 수 있습니다. 또는 개인정보보호책임자 및 담당자에게 서면, 전화 또는 이메일로 연락할 경우에도 본인 확인 절차 후 지체 없이 필요한 내용을 조치 받을 수 있습니다.
③ 개인정보의 오류에 대한 정정을 요청한 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체 없이 통지하여 정정이 이루어지도록 합니다.
④ 회사는 이용자의 요청에 의해 해지 또는 삭제된 개인정보를 제5조(개인정보의 보유 및 이용기간)에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.

제 8 조 [개인정보의 자동 수집 장치의 설치, 운영 및 그 거부에 관한 사항]
① 회사는 이용자에게 개인화되고 맞춤화된 서비스를 제공하기 위해 이용자의 정보를 저장하고 수시로 찾아내는 쿠키(Cookie)를 사용할 수 있습니다. 쿠키는 웹사이트가 이용자의 웹브라우저로 전송하는 소량의 정보입니다.
② 이용자는 쿠키에 대한 선택권을 가지고 있습니다. 이용자는 웹 브라우저에서 [도구] > [인터넷옵션] > [개인정보] > [설정]을 선택함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수 있습니다. 단, 모든 쿠키의 저장을 거부하는 경우, 쿠키를 통해 회사에서 제공하는 서비스를 이용할 수 없습니다.

제 9 조 [개인정보의 기술적/관리적 보호 대책]
회사는 이용자의 개인정보를 처리함에 있어 개인정보가 분실, 도난, 유출, 변조 또는 훼손되지 않도록 안전성 확보를 위해 기술적, 관리적 대책을 마련하고 있습니다.
① 기술적 대책
가. 이용자의 비밀번호는 암호화되어 있어 이용자 본인 외에는 알 수 없습니다.
나. 회사는 암호화 통신을 통하여 네트워크 상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다.
다. 회사는 해킹이나 컴퓨터바이러스 등에 의해 이용자의 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다.
라. 회사는 개인정보의 훼손에 대비하여 자료를 수시로 백업하고 있고, 최신 백신프로그램을 이용하여 컴퓨터바이러스에 의한 피해를 방지하기 위한 조치를 취하고 있습니다.
마. 회사는 시스템에 대한 접근통제, 권한 관리, 취약점 점검 등의 조치를 통해 보안성이 강화될 수 있도록 지속적으로 노력하고 있습니다.
② 관리적 대책
가. 회사는 이용자의 개인정보에 대한 접근권한을 최소한의 인원으로 제한하고 있습니다.
나. 회사는 개인정보처리자를 대상으로 개인정보 보호 의무 등에 관해 정기적인 교육을 실시하고 있습니다.
다. 회사는 개인 정보보호 업무를 전담하는 부서에서 개인 정보처리방침 및 내부 규정 준수 여부를 확인하여 문제가 발견될 경우, 즉시 바로잡을 수 있도록 노력하고 있습니다.
라. 이용자 본인의 부주의나 회사가 관리하지 않는 영역에서의 사고 등 회사의 귀책에 기인하지 않은 손해에 대해서는 회사는 책임을 지지 않습니다.

제 10 조 [영업 양수 등의 통지]
회사는 영업의 전부 또는 일부를 양도하거나 합병, 상속 등으로 그 권리, 의무를 이전하는 경우 이용자에게 관련 내용으로 다음의 항목을 통지합니다.
① 영업의 전부 또는 일부의 양도, 합병 또는 상속의 사실
② 권리, 의무를 승계한 자의 성명, 주소, 연락처

제 11 조 [개인정보보호책임자 및 담당자의 연락처]
① 회사는 이용자의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 다음과 같이 개인정보보호책임자를 두고 있습니다.
가. 개인정보보호책임자
- 성명 백민기 / 전화번호 02-558-2166 / 이메일 martin@cplat.io
나. 개인정보보호담당자
- 성명 이준원 / 전화번호 02-558-2166 / 이메일 mars@cplat.io
② 기타 개인정보 침해에 대한 신고나 상담이 필요하신 경우 다음 기관에 문의하시기 바랍니다.
가. 개인정보침해신고센터(privacy.kisa.or.kr / 국번 없이 118)
나. 대검찰청 사이버범죄수사단(cyberid@spo.go.kr / 02-3480-3571)
다. 경찰청 사이버안전국(cyberbureau.police.go.kr / 국번 없이 182)
라. 개인정보 분쟁조정위원회(kopico.go.kr / 1833-6972)

제 12 조 [링크 사이트]
회사는 이용자에게 다른 회사의 웹사이트에 대한 링크를 제공할 수 있습니다. 이 경우 링크되어 있는 웹사이트가 개인정보를 수집하는 행위에 대해서는 본 개인정보처리방침이 적용되지 않습니다.

제 13 조 [기타]
본 개인정보처리방침의 내용 추가, 삭제 및 수정이 있을 시에는 최소 7일 전부터 홈페이지의 공지사항을 통해 고지할 것입니다.

* 부 칙 *

개정된 방침은 2022년 8월 15일부터 적용됩니다.
개인정보취급방침 공고일자 : 2022년 08월 01일
개인정보취급방침 시행일자 : 2022년 08월 15일

본 방침은 2021년 11월 15일부터 적용됩니다.
개인정보취급방침 공고일자 : 2021년 11월 01일
개인정보취급방침 시행일자 : 2021년 11월 15일`;

const PROMOTION_TERMS_BODY = `제 1 조 [목적]
서클플랫폼 주식회사 (이하 ‘회사’라 한다)가 제공하는 셀러박스 서비스(이하 ‘서비스’라 한다)는 이용자에게 보다 다양한 정보를 제공하고, 서비스의 질을 향상시키기 위하여 「개인정보보호법」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률 」및 「신용정보의 이용 및 보호에 관한 법률」의 규정을 준수하여 회사 또는 회사의 제휴사를 통해 이용자의 개인정보를 상품소개 및 홍보 등 영업목적으로 활용할 수 있습니다.

제 2 조 [수집 및 활용 관련 정보]
개인정보 활용업체, 수집항목 및 이용목적은 아래와 같습니다. 개인정보의 마케팅 정보활용 제공에 관한 동의서에 동의하신 이용자의 정보만 제공되며, 제공된 정보는 명시된 이용목적을 벗어나 이용되지 않고, 개인정보의 유출 등 사고가 일어나지 않도록 더욱 철저한 보안이 이루어지도록 노력하고 있습니다.

활용업체
개인정보 수집 항목
개인정보 수집 이용 목적
보유 및 이용기간
서클플랫폼㈜
상호(법인명), 성명(대표자명), 휴대폰번호, 이메일
- 이벤트 운영 및 광고성 정보 전송
- 서비스 관련 정보 전송
- 유료화 전환 관련 이벤트 안내 및 얼리버드/첫 달 할인 적용 대상자 확인
이용자가 동의를 철회하거나 탈퇴 시까지 보유·이용. 단, 이벤트 종료 후 6개월이 경과한 이벤트 관련 정보는 파기합니다.

제 3 조 [이벤트 및 프로모션 운영 조건]
① 회사는 서비스 유료화 전환과 관련하여 다음과 같은 이벤트를 운영합니다.
얼리버드 이벤트
적용 대상: 이벤트 공지일(2026년 5월)부터 2026년 6월 7일까지 웹에서 유료 멤버십에 가입한 이용자
혜택: 첫 3개월 월 100원 적용
4개월째부터 정가 15,000원으로 자동 전환
웹(PC 및 모바일 웹) 결제 시에만 적용되며, 앱 내 인앱결제 시 미적용
첫 결제 이력 여부와 무관하게 적용
첫 달 할인 이벤트
적용 대상: 2026년 6월 8일 이후 웹에서 신규 유료 멤버십에 가입한 이용자
혜택: 첫 달 100원 적용
2개월째부터 정가 15,000원으로 자동 전환
웹(PC 및 모바일 웹) 결제 시에만 적용되며, 앱 내 인앱결제 시 미적용
② 얼리버드 이벤트와 첫 달 할인 이벤트는 중복 적용되지 않습니다.
③ 이벤트 가격 적용 기간 종료 후 정가 전환 시, 회사는 전환 3일 전 이메일 및 앱 푸시를 통해 이용자에게 사전 고지합니다.
④ 회사는 운영상 필요에 따라 이벤트를 조기 종료하거나 조건을 변경할 수 있으며, 이 경우 사전 공지합니다. 단, 이미 이벤트 가격으로 결제가 완료된 기간에 대해서는 소급 적용하지 않습니다.

제 4 조 [제3자 정보제공의 동의 철회]
본 동의서에 동의하고 가입하신 신규 이용자 중 정보제공을 철회하고 싶은 이용자는 이미 제공된 개인정보라 하더라도, 언제든지 열람, 정정, 삭제를 요구할 수 있습니다. 열람, 정정, 삭제 및 정보제공 동의 철회는 회사 이메일(help@cplat.io)를 통해 요청할 수 있습니다. 회사는 이용자의 소중한 정보를 보호하기 위하여 신속하게 처리되도록 최선의 노력을 다하겠습니다.`;

export const SIGNUP_TERMS = [
  {
    label: '서비스 이용 약관 동의',
    isOptional: false,
    termsContent: (
      <TermsContent
        title="서비스 이용약관"
        dateText={`제정 2021년 11월 01일
개정 2026년 05월 18일`}
        body={SERVICE_TERMS_BODY}
      />
    ),
  },
  {
    label: '개인정보 처리 방침',
    isOptional: false,
    termsContent: (
      <TermsContent
        title="개인정보처리방침"
        dateText={`제정 2021년 11월 01일
개정 2026년 05월 18일`}
        body={PRIVACY_POLICY_BODY}
      />
    ),
  },
  {
    label: '이벤트/프로모션 정보 선택 동의',
    isOptional: true,
    termsContent: (
      <TermsContent title="이벤트/프로모션 정보 선택 동의" body={PROMOTION_TERMS_BODY} />
    ),
  },
];
